import React, { Component } from 'react';
import { connect } from 'react-redux';
import { AppState, Actions, store, PanelState, IPageState } from '../appredux'

import { Trans, WithTranslation, withTranslation } from 'react-i18next';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';
import { Theme } from "@material-ui/core/styles";
import { Paper, WithStyles } from '@material-ui/core';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';

import MenuComponent from './Menu';


import CONFIG from '../cfg/config';

import './Paper.css'
import './PanelRightBasket.css'
import './LeftPanel.css';
import { fontSelect } from '../fonts'
import DialogErrorMinimum from './dialog/DialogErrorMinimum';
import { dostepnePrioryety } from './common/helpers';

//PM 2021-06-25
interface PanelLeftTestProps {
  page: IPageState,
}

interface PanelLeftTestState {
  openDialogError: boolean,
}

class PanelLeftTest extends React.Component<PanelLeftTestProps & WithStyles<typeof styles>, PanelLeftTestState>  {
  textTheme = fontSelect(this.props.page.fonts, 3, 1) as React.CSSProperties;
  selectedTheme = fontSelect(this.props.page.fonts, 13, 1) as React.CSSProperties;
  contentTheme = fontSelect(this.props.page.fonts, 4, 2) as React.CSSProperties;
  

  constructor(props: PanelLeftTestProps & WithStyles<typeof styles>) {
    super(props, {});

    this.state = {
      openDialogError: false,   
    };
    
  }

  closeDialogError = () => {
    this.setState({ openDialogError: false })
  };

  selectItem = (id: number) => {

    let selectedMenuItem = this.props.page.menuItems.find(x => x.menu_id === this.props.page.selectedMenuItem)
    if(selectedMenuItem && this.props.page.asortymentowWGrupie >= selectedMenuItem.zamowienie_min_ilosc_pozycji || this.props.page.asortymentowWGrupie === 0){

      store.dispatch(Actions.pageState.selectMenuItem(id));

      let priorytety = dostepnePrioryety(this.props.page.asortHeaders, id)
      
      store.dispatch(Actions.pageState.setPriorytet(priorytety[0], priorytety[0], priorytety[priorytety.length - 1]));
      store.dispatch(Actions.pageState.setAsortymentowWGrupie(0))  
      store.dispatch(Actions.pageState.resetBoldy())  

    } else {
      this.setState({openDialogError : true})
    }

   


    //console.log(this.props.page.selectedMenuItem)
  };

  // componentDidUpdate(prevProps: PanelLeftTestProps) {
  //   if(prevProps.page.menuItems !== this.props.page.menuItems){
  //     //this.setState({startDate: new Date(Date.parse(this.props.page.dateFrom))});
  //   }  
  //   if(prevProps.page.selectedMenuItem !== this.props.page.selectedMenuItem){
  //     //this.setState({startDate: new Date(Date.parse(this.props.page.dateFrom))});
  //   } 
  // }

  //PM 2021-06-25
  render = () => {
    const { classes } = this.props;

    return (
      <>
      <Paper elevation={3}>
        <List style={{ paddingTop: "0", paddingBottom: "0", border: "1px solid #CCC", borderRadius: "4px" }}>
          <ListItem style={{ borderBottom: "1px solid #CCC", textAlign: "center", padding: "5px 10px 5px 10px" }} key={-1}  >
            <ListItemText style={{margin: "0"}} primary={<Typography color="primary" variant="h6" component="h2" style={{...this.textTheme, width: "100%", display: "inline-flex", minHeight: "40px"}} ><MenuComponent/><span style={{width: "100%", margin: "auto", textAlign: "center"}}>Oferta</span></Typography>} />
          </ListItem>

          {CONFIG.kelnerBookFoto === '2' || CONFIG.kelnerBookFoto === '3' ?
            <div style={{ padding: "10px 3px 10px 8px" }}>
              {this.props.page.menuItems.map((item: any, index: any) => (
                <ListItem className={classes.list}
                  key={index}
                  button
                  onClick={() => this.selectItem(item.menu_id)}
                  //selected={this.props.page.selectedMenuItem == item.menu_id ? true : false}
                >
                  <ListItemText primary={<Typography color="primary" component="h6" style={{ ...this.contentTheme, color: this.props.page.selectedMenuItem == item.menu_id ? this.selectedTheme.color : this.contentTheme.color }} dangerouslySetInnerHTML={{ __html: item.opis.split("|").join("<br>") }}></Typography>} />
                </ListItem>
              ))}
            </div> :
            <div style={{ padding: "10px 3px 10px 8px" }}>
              {this.props.page.menuItems.map((item: any, index: any) => (
                <ListItem className={classes.list}
                  key={index}
                  button
                  onClick={() => this.selectItem(item.menu_id)}
                  selected={this.props.page.selectedMenuItem == item.menu_id ? true : false}
                >
                  <ListItemText primary={<Typography color="primary" component="h6" style={{ ...this.contentTheme }} dangerouslySetInnerHTML={{ __html: item.opis.split("|").join("<br>") }}></Typography>} />
                </ListItem>
              ))}
            </div>}



        </List>
      </Paper>

      <DialogErrorMinimum open={this.state.openDialogError} close={this.closeDialogError} />
      </>
    )
  }
}

//do wywalenia
const styles = (theme: Theme) => {
  return ({
    list: {
      borderTop: "1px solid rgba(224, 224, 224, 1)",
      borderBottom: "0",
      paddingLeft: "10px",
      paddingRight: "10px",
      // "&:first-child": {
      //   borderTopRightRadius: "4px",
      //   borderTopLeftRadius: "4px"
      // }
      "&:last-child": {
        borderBottom: "1px solid rgba(224, 224, 224, 1)"
      }
    },
    root: {
      paddingLeft: '15px',
      paddingRight: '15px',
      fontFamily: theme.typography.fontFamily,
      fontSize: theme.typography.fontSize,
    },
    paper: {
      marginBottom: "1em",
      background: "linear-gradient(to bottom, #ffffff, #f7f7f7)",
      padding: "16.9px 1px 11.9px ",
      width: "-webkit-fill-available"
    },
    primary: {
      //color: theme.palette.primary.main,
      color: "#3a87ad",
      padding: "9px 14px 9px 0"
    },
    headline: {
      fontFamily: "\"'Open Sans'\", sans-serif",
      lineHeight: "20px",
      fontSize: "14px",
      fontWeight: 600
    },
    hr: {
      marginRight: "14px",
      borderTop: "1px solid rgba(224, 224, 224, 1)"
    },
    price: {
      fontWeight: 'bold' as 'bold',
      fontSize: "12px",
      color: "#3a87ad",
    },
    button: {
      backgroundColor: "rgb(0, 144, 0)",
      border: "none", color: "white",
      borderRadius: "4px",
      boxShadow: "0 2px 2px rgba(0,0,0,.2)",
      textDecoration: "none",
      fontWeight: 100,
      marginBottom: "10px",
      width: "40px",
      fontSize: "22px",
      height: "35px",
      cursor: "pointer",
      display: "inline-block",
      padding: "5px 5px",
    },
    date: {
      color: theme.palette.primary.main,
      padding: "8px 2px"
    },
    back: {
      margin: "8px 8px 8px 0px",
      color: "#ffffff",
      textShadow: "0 -1px 0 rgba(0, 0, 0, 0.25)",
      background: "linear-gradient(to bottom, #e49a4d, #c9823c)",
      //padding: "8px 10px 7px", 
      lineHeight: "15px",
      fontSize: "13px",
      border: "1px solid rgba(201, 130, 60, 0.5)",
      "&:hover": {
        border: "1px solid rgba(201, 130, 60, 0.5)"
      }
    },
    select: {
      margin: "8px 8px 8px 0px",
      color: "#ffffff",
      textShadow: "0 -1px 0 rgba(0, 0, 0, 0.25)",
      background: "linear-gradient(to bottom, #69b076, #458B00)",
      //padding: "8px 10px 7px", 
      lineHeight: "15px",
      fontSize: "13px",
      border: "1px solid rgba(69, 139, 0, 0.5)",
      "&:hover": {
        border: "1px solid rgba(201, 130, 60, 0.5)"
      }
    }
  });
}

const mapStateToProps = (state: AppState) => ({
  page: state.pageState
});

//export default PanelLeftTest;
export default connect(mapStateToProps)(withStyles(styles)(PanelLeftTest));









